export const deepClone = <T>(obj: T): T => structuredClone(obj);
